import React from 'react'
import { string, func } from 'prop-types'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'

import { media } from 'styles/media'
import { white } from 'styles/colors'
import { cover, animationTime, animationCurve } from 'styles/global'
import { H2, fontSizes } from 'styles/typography'

const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  background: ${props => props.background};
  user-select: none;
  cursor: pointer;
  width: 100%;
  height: 100%;
`

const ImageWrap = styled.div`
  width: 60%;
  position: relative;
  max-width: 240px;

  &:after {
    content: '';
    display: block;
    padding-bottom: 100%;
    width: 100%;
  }
`

const Image = styled.img`
  width: 100%;
  border-radius: 50%;
  ${cover('absolute')};
  object-fit: cover;
  transition: filter ${animationTime} ${animationCurve};

  ${Container}:hover & {
    filter: drop-shadow(3px 6px 20px rgba(0, 0, 0, 0.3));
  }
`

const Name = styled.span`
  display: block;
  font-size: ${fontSizes.small};
  text-transform: uppercase;
  color: ${white};
  margin-top: 7.5%;
  letter-spacing: 0.1em;

  ${media.large`
    margin-top: 5%;
  `};
`

const Heading = styled(H2)`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  color: ${white};
  text-transform: uppercase;
  text-align: center;
  font-family: 'Trim Poster';
  margin-top: 5%;
  display: block;
  margin-bottom: 0;
`

const Flavour = ({ name, background, onClick, slug }) => {
  const isNicotineFree = slug === 'nicotine-free'

  return (
    <Container background={background} onClick={onClick}>
      <ImageWrap>
        {isNicotineFree ? (
          <Heading as="span">Nicotine free</Heading>
        ) : (
          <LazyLoad>
            <Image src={`${process.env.BASE_PATH}/images/home/offers/flavours/${slug}.png`} alt={name} />
          </LazyLoad>
        )}
      </ImageWrap>
      <Name>{name}</Name>
    </Container>
  )
}

Flavour.propTypes = {
  name: string.isRequired,
  background: string.isRequired,
  slug: string.isRequired,
  onClick: func.isRequired
}

export default Flavour
